import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'plural',
  standalone: true,
})
export class PluralPipe implements PipeTransform {
  transform(value: number, word: string): string {
    if (word == null || typeof word !== 'string') {
      return '';
    }
    return value > 1 ? `${word}s` : word;
  }
}
